export enum DaterangesQuickOptsEnum {
  today,
  yesterday,
  last7days,
  last30days,
  thisMonth,
  lastMonth,
  customRange
}
